import { Injectable } from '@angular/core';
import { StorageService } from './../Storage/storage.service';
import { Params } from '@angular/router';
import { LoggerApiService } from '../logger/logger-api.service';
import { environment } from '../../../environments/environment';

interface BrazeEventData {

}

export interface BrazeUserAttributes {
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  city?: string;
  customAttrr?: { key: string, value: any }[];
}

@Injectable({
  providedIn: 'root'
})
export class BrazeService {
  private _brazeProcessEventName: string;
  get brazeProcessEventName(): string {
    if (!this._brazeProcessEventName) {
      this._brazeProcessEventName = this.storageService.getBrazeBaseProcessEventName() || 'self_process';
    }
    return this._brazeProcessEventName;
  }

  set brazeProcessEventName(brazeEventName: string) {
    this._brazeProcessEventName = brazeEventName;
    this.storageService.saveBrazeBaseProcessEventName(brazeEventName);
  }


  constructor(private storageService: StorageService, private loggerApiService: LoggerApiService) {

  }

  initBraze(): void {
    const braze = window['braze'];
    if (!braze) {
      console.error('Braze SDK not loaded'); 
      return;
    }
    
    // initialize the SDK
    braze.initialize(environment.brazeApiKey, {
      baseUrl: environment.brazeSdkEndPoint,
      enableLogging: true
    });

    // optionally show all in-app messages without custom handling
    braze.automaticallyShowInAppMessages();

    // if you use Content Cards
    braze.subscribeToContentCardsUpdates(function(cards) {
      // cards have been updated
    });

    // optionally set the current user's external ID before starting a new session
    // you can also call `changeUser` later in the session after the user logs in
    // if (isLoggedIn){
    //   braze.changeUser(userIdentifier);
    // }

    // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
    braze.openSession();
  }

  /** *** MAYBE WE ARE NOT ALLOWED to use user identity number in marketing data*** for identity number (tz) only */
  setBrazeUserAlias(identityNumber: string): void {
    const braze = window['braze'];
    if (!braze) {
      console.error('Braze SDK not loaded');
      return;
    }
    // use alias, the userId should be customer id
    // braze.getUser().addAlias(ALIAS_NAME, ALIAS_LABEL); --> name = tz number, label = 'tz'
    // https://www.braze.com/docs/developer_guide/analytics/setting_user_ids/#how-they-work
    braze.getUser().addAlias(identityNumber, 'tz');
  }

  /** When we have customer id of bezeq */
  setBrazeUserId(userId: string): void {
    const braze = window['braze'];
    if (!braze) {
      console.error('Braze SDK not loaded'); 
      return;
    }
    braze.changeUser(userId);
  }

  // make methods to set email/ first name/ last name / phone number
  // https://www.braze.com/docs/developer_guide/analytics/setting_user_attributes/?sdktab=web
  sendBrazeUserAttributes(userAttr: BrazeUserAttributes): void {
    const braze = window['braze'];
    if (!braze) {
      console.error('Braze SDK not loaded'); 
      return;
    }
    userAttr = userAttr || {};
    const brazeUser = braze.getUser();

    if (userAttr.email) {
      brazeUser.setEmail(userAttr.email);
    }
    if (userAttr.firstName) {
      brazeUser.setFirstName(userAttr.firstName);
    }
    if (userAttr.lastName) {
      brazeUser.setLastName(userAttr.lastName);
    }
    if (userAttr.phoneNumber) {
      // phone number should be in E.164 format, e.g. +972501234567
      let phoneNumber = userAttr.phoneNumber.trim();
      if (phoneNumber.startsWith('0')) {
        phoneNumber = `+972${phoneNumber.substring(1)}`;
      }
      brazeUser.setPhoneNumber(phoneNumber);
    }
    if (userAttr.city) {
      brazeUser.setHomeCity(userAttr.city);
    }
    if (Array.isArray(userAttr.customAttrr)) {
      userAttr.customAttrr.forEach((attr) => {
        brazeUser.setCustomUserAttribute(attr.key, attr.value);
      });
    }

  }

  sendBrazeCustomEvent(eventName: string, eventData: BrazeEventData): void {
    const braze = window['braze'];
    if (!braze) {
      console.error('Braze SDK not loaded'); 
      return;
    }

    this.storageService.saveBrazeEventDataCache(eventData);

    // if (sendCachedEventData) {
    //   const cachedEventData = this.storageService.getBrazeEventDataCache();
    //   if (cachedEventData) {
    //     eventData = { ...cachedEventData, ...eventData };
    //   }
    // }
    
    braze.logCustomEvent(eventName, eventData);

    this.loggerApiService.sendEventLog({
      brazeEventName: eventName,
      ...eventData,
    });

  }

  // sendBrazeCustomEventFromArray(eventName: string, eventData: { key: string, value: any }[]): void {
  //   if (!Array.isArray(eventData)) {
  //     console.error('eventData is not an array');
  //     return;
  //   }
  //   if (!eventData?.length) {
  //     return;
  //   }
  //   const brazeEventData: { [key: string]: any } = {};
  //   eventData.forEach((item) => {
  //     brazeEventData[item.key] = item.value
  //   });

  //   this.sendBrazeCustomEvent(eventName, brazeEventData);
  // }
}
